import { render } from "./CustomSearch.vue?vue&type=template&id=3c6082af"
const script = {}

import "./CustomSearch.vue?vue&type=style&index=0&id=3c6082af&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__